import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
    Box, Button, Card, CardHeader, CardContent, Typography,
    Grid, FormControl, FormGroup, FormLabel, OutlinedInput,
    Select, MenuItem
} from '@material-ui/core'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError } from 'config/lib/errorLib'
import { NotificationManager } from 'react-notifications'
import Loader from 'components/general/Loader'
import CountySelect from 'components/general/CountySelect'
import ReactDropzoneCropper from 'components/general/ReactDropzoneCropper'
import config from 'config/api/Config'
import { Storage } from 'aws-amplify'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import ProjectType from 'components/provider/ProjectType'
import componentStyles from 'assets/theme/views/admin/react-bs-table.js'
import Project from './Project'
import EditProjectCard from './EditProjectCard'

const useStyles = makeStyles(componentStyles)

function ProjectPreviewCard({ companyDetails, project, updateCompany, updateField }) {
    const classes = useStyles()
    const api = new ProviderAPI()
    const projectId = project.projectId
    const [editing, setEditing] = useState(false)
    const [image, setImage] = useState(null)
    const [imagePreview, setImagePreview] = useState(project.image || '')
    const [loading, setLoading] = useState(false)
    const [showEditDialog, setShowEditDialog] = useState(false)

    // Pull values from props.project
    const type = project.type || ''
    const category = project.category || ''
    const county = project.county || ''

    async function deleteProject() {
        setLoading(true)
        try {
            const updatedProjects = companyDetails.projects.filter(p => p.projectId !== projectId)
            const company = await api.updateProjects(companyDetails.companyId, updatedProjects)
            updateCompany(company)
            NotificationManager.success('Case Study deleted')
        } catch (e) {
            onError(e)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box>
            <Project project={project} />
            <Grid container>
                <Grid item xs={12}>
                    <Box display='flex' justifyContent='flex-end' width='100%'>
                        <Button
                            variant='outlined'
                            color='primary'
                            onClick={() => deleteProject()}
                            style={{ marginRight: '1rem' }}
                        >
                            Delete
                        </Button>
                        <Button
                            variant='outlined'
                            color='primary'
                            onClick={() => setShowEditDialog(true)}
                        >
                            Edit
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            <EditProjectCard
                open={showEditDialog}
                onClose={() => setShowEditDialog(false)}
                project={project}
                company={companyDetails}
                updateCompany={updateCompany}
                updateField={updateField}
            />
        </Box>
    )
}

export default ProjectPreviewCard